import type { Draft } from "immer"
import type { BonusAction } from "./actions"
import reducerBasket from "./reducer-basket"
import reducerBonus from "./reducer-bonus"
import reducerBundle from "./reducer-bundle"
import reducerDomainBox from "./reducer-domain-box"
import reducerDomainSearch from "./reducer-domain-search"
import reducerEmailHack from "./reducer-email-hack"
import reducerForm from "./reducer-form"
import reducerProduct from "./reducer-product"
import reducerUpsell from "./reducer-upsell"
import { initialState } from "./selectors"
import type { BonusState } from "./types"

const reducers = [
  reducerBonus,
  reducerBasket,
  reducerBundle,
  reducerDomainBox,
  reducerDomainSearch,
  reducerEmailHack,
  reducerProduct,
  reducerUpsell,
  reducerForm,
]

export default function reducer(
  state: BonusState = initialState,
  action: BonusAction
): BonusState {
  let previousState: BonusState = state
  let nextState: Draft<BonusState> = initialState
  reducers.forEach((reducer) => {
    // @ts-ignore: TypeScript cannot reconcile the BonusAction union across separate reducer files; merging all reducers into one file would be the only proper fix
    nextState = reducer(previousState, action)

    if (nextState !== previousState) {
      // @ts-ignore: same as above — cross-file action type narrowing is not supported
      previousState = nextState
    }
  })

  // @ts-ignore
  return nextState
}
